import React, { Component, Fragment } from 'react';
import { Col, Row, Container } from 'reactstrap';
//import { Link } from 'react-router-dom';

import Helmet from 'react-helmet';

import Css from './ExperiencesLandingPage.scss';
import NavigationFooter from './NavigationFooter/NavigationFooter';
import RecommendationTile from './RecommendationTile/RecommendationTile';
import ThingsFrame from './ThingsToDoTile/ThingsToDoTile';
import Disclaimer from '@components/Experiences/Disclaimer/Disclaimer';
import NextSteps from '@components/Experiences/NextSteps/NextSteps';
import CityData from './LandingPageData';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');

class ExperiencesLandingPage extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    let RecommendationContents = [];

    let WhyVisitText = [];

    let ThingsToDoContents = [];

    const landingData = CityData[this.props.slug];

    //seperates paragraphs for the 'Why Visit' section Text Box
    landingData.WhyVisitText.split('\n').forEach(function(cur, ind) {
      WhyVisitText.push(<p key={ind}>{cur}</p>);
    });

    landingData.RecommendedLocales.forEach((cur, index) =>
      RecommendationContents.push(
        <RecommendationTile
          {...cur}
          index={index + 1}
          key={index}
          location={landingData.Location}
        />
      )
    );

    landingData.ThingsToDo.forEach((cur, index) =>
      ThingsToDoContents.push(<ThingsFrame {...cur} key={index} />)
    );

    return (
      <Fragment>
        <Helmet>
          <title>JetSuite Experiences | JetSuite</title>
          <meta name="description" content={'Why ' + landingData.Location} />
        </Helmet>
        <div
          className={'pt-5 pb-5 ' + Css['background-box']}
          style={{
            backgroundImage: 'url(' + landingData.Image + ')',
            backgroundSize: '100% auto',
            backgroundPosition:
              this.props.slug === 'aspen' ||
              this.props.slug === 'nashville' ||
              this.props.slug === 'd-c'
                ? 'center'
                : this.props.slug === 'west-palm-beach-miami' ||
                  this.props.slug === 'toronto'
                  ? 'center bottom'
                  : 'auto'
          }}
        >
          <Container>
            <Row>
              <Col className={'pt-5 pb-4'}>
                <div className={'mt-5 mb-5 p-4 background-transblack'}>
                  <h1 className={Css.header}>{landingData.Title}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div
          style={{
            backgroundImage: `url(${Clouds})`,
            backgroundSize: '100% auto'
          }}
          className={'pb-2 ' + Css['background-box']}
        >
          <Container>
            <Row className={'mb-5'}>
              <Col
                className={
                  Css['why-header'] + ' text-center font-xl pt-5 lakes-medium'
                }
              >
                Why {landingData.Location}
              </Col>
            </Row>
            <Row>
              <Col
                sm={5}
                className={'position-relative ' + Css['why-image']}
                style={{ zIndex: 1 }}
              >
                <div className={'d-flex align-items-center h-100'}>
                  <img
                    src={landingData.WhyVisitImage}
                    alt={''}
                    className={'img-fluid'}
                  />
                </div>
              </Col>
              <Col md={7} className={Css['why-description']}>
                <div
                  className={
                    Css.regular +
                    ' text-justify py-4 px-5 background-red d-flex align-items-center'
                  }
                >
                  <div>{WhyVisitText}</div>
                </div>
              </Col>
            </Row>

            <Row className={'mb-3'}>
              <Col
                className={
                  Css['why-header'] + ' text-center font-xl pt-5 lakes-medium'
                }
              >
                Featured Activities
              </Col>
            </Row>
            <Row className={'pb-5'}>{ThingsToDoContents}</Row>
          </Container>
        </div>

        {/* Our Recommendations */}
        <Container>
          <Row>
            <Col
              className={
                Css['why-header'] + ' text-center font-xl pt-5 lakes-medium'
              }
            >
              Hotel Recommendations
            </Col>
          </Row>
          <Row className={'pb-5'}>{RecommendationContents}</Row>
        </Container>

        {/* Next Steps */}
        <NextSteps
          pageWidth={this.props.pageWidth}
          location={landingData.Location}
          eventName={landingData.Location + ' Join Button Clicks'}
        />

        <Container className={'pt-4'}>
          <NavigationFooter location={landingData.Location} />
        </Container>

        <Disclaimer className={'pt-2 px-3 pb-5 font-xs text-justify'} />
      </Fragment>
    );
  }
}
export default ExperiencesLandingPage;



// WEBPACK FOOTER //
// ./src/components/ExperiencesLandingPage/ExperiencesLandingPage.js